import Model from 'ln/model/Model';
import {Resolvable} from 'ln/components/Resolve';

import {Asset} from '../../Asset';
import {Chapter} from '../chapter';
import { StepByStep } from 'components/stepbystep';


export interface ModuleRequestHandler {
    navigateToChapterList(): void;
    restoreScroll(): void;
    saveScroll(): void;
    scrollToTop(): void;
}


export class Module extends Model implements Resolvable {

    public constructor(json: object) {
        super({
            chapters: [],
            completionCount: 0,
            completionInPercent: 0,
            image: null,
            scrollHintOpacity: 1,
            selectedChapter: null,
            showSelectedChapter: false,
            title: '',
            ...json
        });

        if (this.chapters.length) {
            for (const chapter of this.chapters) {
                chapter.module = this;
                chapter.change.filter(property => property.name === 'completed')
                              .subscribe(() => this.onChapterCompletionChanged(chapter));
            }
            this.selectedChapter = this.chapters[0];
        }
    }

    public readonly chapters: Chapter[];
    public completionCount: number;
    public completionInPercent: number;
    public readonly image: Asset;
    public request: ModuleRequestHandler;
    public scrollHintOpacity: number;
    public selectedChapter: Chapter;
    public showSelectedChapter: boolean;
    public readonly title: string;

    public getViewName(): string {
        return 'Module';
    }

    public closeChapter(): void {
        this.showSelectedChapter = false;
        this.request.restoreScroll();
    }

    public navigateToChapterList(): void {
        this.request.navigateToChapterList();
    }

    public openChapter(chapter: Chapter): void {
        this.request.saveScroll();
        this.selectedChapter = chapter;
        this.showSelectedChapter = true;
        this.request.scrollToTop();
    }

    private onChapterCompletionChanged(chapter: Chapter): void {
        if (chapter === this.selectedChapter) {
            /* if (chapter.completed) {
                setTimeout(this.closeChapter.bind(this), 500);
            } */
            this.completionCount = this.chapters.filter(ch => ch.completed).length;
            this.completionInPercent = Math.trunc(100 * this.completionCount / this.chapters.length);
        }
    }
}
